import BStep from './packages/BStep'

BStep.install = function(Vue) {
    Vue.component(BStep.name, BStep)
}

export default BStep
